import React, { useEffect, useState } from "react";
import UserDataComponent from "./UserDataComponent";
import CourseDataComponent from "./CourseDataComponent";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { MonoButton } from "../kits";
import RegistrationDataComponent from "./RegistrationDataComponent";

function AdminDashboard() {
  const [users, setUsers] = useState([]);
  const [courses, setCourses] = useState([]);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [registrations, setRegistrations] = useState([]);


  //Regestrierte Kurse 

  useEffect(() => {
  fetch("https://www.denisbitter.de/stage01/api/get_course_registrations.php")
    .then(res => res.json())
    .then(data => data.success ? setRegistrations(data.data) : setError("Fehler beim Laden der Registrierungen"))
    .catch(() => setError("Verbindungsfehler bei Registrierungsliste."));
}, []);

  // Benutzer laden
  useEffect(() => {
    fetch("https://www.denisbitter.de/stage01/api/admin_dashboard.php")
      .then(res => res.json())
      .then(data => data.success ? setUsers(data.data) : setError(data.message))
      .catch(() => setError("Fehler beim Abrufen der Benutzer."));
  }, []);

  // Benutzer löschen
  const deleteUser = (id) => {
    if (window.confirm("Benutzer wirklich löschen?")) {
      fetch(`https://www.denisbitter.de/stage01/api/delete_user.php?id=${id}`, {
        method: "DELETE"
      })
        .then((res) => {
          if (!res.ok) throw new Error("Fehler beim Löschen");
          setUsers(prev => prev.filter(user => user.id !== id));
        })
        .catch(() => alert("Fehler beim Löschen des Benutzers."));
    }
  };

  // Kurse laden
  useEffect(() => {
    fetch("https://www.denisbitter.de/stage01/api/get_courses.php")
      .then(res => res.json())
      .then(data => data.success ? setCourses(data.data) : setError("Kursdatenfehler"))
      .catch(() => setError("Fehler beim Laden der Kurse."));
  }, []);

  // Kurs löschen
  const deleteCourse = (slug) => {
    if (window.confirm("Kurs wirklich löschen?")) {
      fetch(`https://www.denisbitter.de/stage01/api/delete_course.php?id=${slug}`, {
        method: "DELETE"
      })
        .then((res) => {
          if (!res.ok) throw new Error("Fehler beim Löschen des Kurses");
          setCourses(prev => prev.filter(course => course.slug !== slug));
        })
        .catch(() => alert("Fehler beim Löschen des Kurses."));
    }
  };

  // Kurs bearbeiten
  const editCourse = (slug) => {
    navigate(`/course/edit/${slug}`);
  };

  // Kurs favorisieren
  const toggleFavorite = (id) => {
    const course = courses.find(c => c.id === id);
    if (!course) return;

    const newFavorite = course.isFavorite === "1" || course.isFavorite === true ? "0" : "1";

    const updated = courses.map(c =>
      c.id === id ? { ...c, isFavorite: newFavorite } : c
    );
    setCourses(updated);

    fetch(`https://www.denisbitter.de/stage01/api/update_course.php?id=${id}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ isFavorite: newFavorite })
    }).catch(() => alert("Fehler beim Aktualisieren."));
  };

  return (


    <>

  <section className="max-w-4xl mx-auto mt-10">
          <h1 className="text-2xl font-bold mb-6">Admin Dashboard</h1>
  </section>


    <section className="max-w-4xl mx-auto mt-10">
            <div className="mt-10 ">
        
    <div className="text-sm font-semibold ">Smart Editor - WissenBlog + ZenCode</div>
        <div className="pt-4">
        <span className="space-x-4">



          <Link to="/smarteditor">
  <MonoButton className="text-xs ">
    BLOG Artikel schreiben 
  </MonoButton>
</Link>
                
                <Link to="/smartzeneditor">
  <MonoButton className="text-xs ">
    ZenCode Artikel Schreiben 
  </MonoButton>
</Link>

                <Link to="/smartcaseeditor">
  <MonoButton className="text-xs ">
    CaseStudy Artikel schreiben 
  </MonoButton>
</Link>




        </span>
        </div>



      </div>
    </section>

    <section className="max-w-4xl mx-auto mt-10">
      <RegistrationDataComponent registrations={registrations} />

    </section>
    <div className="max-w-4xl mx-auto mt-10">



        

      {error && <p className="text-red-500">{error}</p>}
      <UserDataComponent users={users} onDeleteUser={deleteUser} />
      <CourseDataComponent
        courses={courses}
        onDelete={deleteCourse}
        onEdit={editCourse}
        onToggleFavorite={toggleFavorite}
      />
    </div>
    </>
  );
}

export default AdminDashboard;
